import { render } from "./LowerThird.vue?vue&type=template&id=48aeae76"
import script from "./LowerThird.vue?vue&type=script&lang=js"
export * from "./LowerThird.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__